export default {
  methods: {
    showAlert(message, action,category) {
      bus.$emit('newToastMessage', message, action ,category);
    },
  },
};
